import { createWidgetNormalizer } from '../create-widget-normalizer';

/**
 * Button declares no synonym RULES — only the flat keys its per-tool folds consume. `foldData`
 * differs per tool, which is why it arrives as an argument rather than a declaration: create wraps a
 * flat label INTO `{ buttons: [{ label }] }`, update unwraps a copied `buttons` wrapper into its
 * flat partial-item patch. See the create/update schema files for each fold and the live failure it
 * was written against.
 */
const buttonNormalizer = createWidgetNormalizer({
    extraFlatKeys: ['label', 'text', 'buttonText'],
});

export function normalizeButtonWidgetArgs(
    raw: unknown,
    foldData: (args: Record<string, unknown>, data: Record<string, unknown>) => Record<string, unknown>
): unknown {
    return buttonNormalizer.normalize(raw, foldData);
}
